if (!customElements.get("faq-list-row")) {
  class FAQListRow extends HTMLElement {
    constructor() {
      super();

      this.answer = this.querySelector(".faq-list__answer");
      this.questionContainer = this.querySelector(
        ".faq-list__question-container"
      );
      this.questionIcon = this.querySelector(".faq-list__question-icon");

      const index = parseInt(this.getAttribute("data-index"));
      if (index === 1) {
        this.questionContainer.classList.remove(
          "js-faq-list__question-container--closed"
        );
        this.answer.classList.remove("js-faq-list__answer--closed");
      }

      this.questionContainer.addEventListener(
        "click",
        this.toggleOpenClose.bind(this)
      );
    }

    isClosed() {
      return this.answer.classList.contains("js-faq-list__answer--closed");
    }

    open() {
      this.answer.classList.remove("js-faq-list__answer--closed");
      this.questionContainer.classList.remove(
        "js-faq-list__question-container--closed"
      );
      this.questionIcon.innerHTML = "−";
    }

    close() {
      this.answer.classList.add("js-faq-list__answer--closed");
      this.questionContainer.classList.add(
        "js-faq-list__question-container--closed"
      );
      this.questionIcon.innerHTML = "+";
    }

    toggleOpenClose() {
      this.isClosed() ? this.open() : this.close();
    }
  }

  customElements.define("faq-list-row", FAQListRow);
}
